import React, {Fragment} from 'react';
import {Button, Card, Input, notification, Popconfirm, Row, Space, Tag, Typography} from "antd";

import {CopyOutlined, MailOutlined, PhoneOutlined, WhatsAppOutlined,} from '@ant-design/icons';

import ApiService from "../../../../services/ApiService"
import ModalEdit from "../ModalEdit";
import ModalAddDoc from "../ModalAddDoc";
import ModalAddLink from "../ModalAddLink";
import ModalAddField from "../ModalAddField";
import IntlMessage from "../../../../components/util-components/IntlMessage";
import ModalUser from "../../../../modals/ModalUser";
import ModalCerfa from "../../../../modals/ModalCerfa";
import ModalAddTag from "../ModalAddTag";
import ModalAddFamille from "../ModalAddFamille";
import ModalPromesse from "../../../../modals/ModalPromesse";
import ModalAddCom from "../ModalAddCom";
import ModalEditAdresse from "../ModalEditAdresse";
import ModalAddChild from "../ModalAddChild";
import ModalContact from "../../../../modals/ModalContact";
import ModalAddFamilyLink from "../ModalAddFamilyLink";
import PermissionAlert from "../../../../components/permissions/PermissionAlert";
import {checkForfait, checkPermissions} from "../../../../components/permissions/functions";
import ContactIcon from "../../../../components/util-components/ContactIcon";
import ModalAddTel from "../ModalAddTel";
import ModalAddEmail from "../ModalAddEmail";
import ModalMergeContact from "../ModalMergeContact";
import ModalActivity from "../ModalActivity";
import {FicheHeader} from "./fiche-header";
import {FicheActions} from "./fiche-actions";
import {FicheParents} from "./fiche-parents";
import {FicheCategories} from "./fiche-categories";
import {FicheFamilles} from "./fiche-familles";
import {FicheTels} from "./fiche-tels";
import {FicheEmails} from "./fiche-emails";
import {FicheInfos} from "./fiche-infos";
import {FicheTabs} from "./fiche-tabs";
import {FicheShared} from "./fiche-shared";
import {isMobile} from "react-device-detect";
import ModalAbonnement from "../../../../modals/ModalAbonnement";
import ModalHazkara from "../ModalHazkara";
import {FicheAccess} from "./fiche-access";

const {Search} = Input;
const {Text, Title} = Typography


export default class Index extends React.Component {

    state = {
        familles: [],
        selected: null,
        loading: true
    }

    async getData() {
        var res = await ApiService.get("/contact/id/" + this.props.id)
        console.log(res)

        if (res.success) {
            this.setState({loading: false, selected: res.data}, () => this.unNew())
        } else {
            console.log("CONTACT INTROUVABLE")
        }
    }


    componentDidMount() {
        this.getData()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.id != this.props.id) {
            this.getData()
        }
    }

    async unNew() {
        const selected = this.state.selected
        if (selected.new) {
            await ApiService.get("/contact/unnew/" + selected.id)
            await this.getData()
        }
    }

    async star(checked = true) {
        const selected = this.state.selected
        await ApiService.get("/contact/" + (checked ? "star" : "unstar") + "/" + selected.id)
        await this.getData()

    }

    async onDelete(id, type = "document") {
        if (!checkPermissions(["contact.edit"]) || !checkForfait(["CRM", "COM", "FULL"])) {
            notification.error({
                message: <IntlMessage id="access.error"/>
            })
            return false
        }

        const selected = this.state.selected

        await ApiService.post("/contact/" + type + "/delete/" + id + "/" + selected.id)
        await this.getData()

        notification.success({
            message: <IntlMessage id="success.delete"/>
        })
    }

    async onUnarchiveContact() {
        if (!checkPermissions(["contact.edit"]) || !checkForfait(["CRM", "COM", "FULL"])) {
            notification.error({
                message: <IntlMessage id="access.error"/>
            })
            return false
        }

        const selected = this.state.selected

        await ApiService.post("/contact/unarchive/" + selected.id)
        await this.getData()
        await this.props.parent.getData(true)


        notification.success({
            message: <IntlMessage id="success.delete"/>
        })
    }

    formatFamilyLink(type, homme = null) {
        var text = ""

        switch (type) {
            case "PERE":
                text = "Père / Mère"
                if (homme === true) {
                    text = "Père"
                }
                if (homme === false) {
                    text = "Mère"
                }
                return <Tag color={"green"}>{text}</Tag>

            case "MARI":
                text = "Conjoint / Conjointe"
                if (homme === true) {
                    text = "Conjoint"
                }
                if (homme === false) {
                    text = "Conjointe"
                }
                return <Tag color={"orange"}>{text}</Tag>

            case "ENFANT":
                text = "Enfant"
                if (homme === true) {
                    text = "Fils"
                }
                if (homme === false) {
                    text = "Fille"
                }
                return <Tag color={"blue"}>{text}</Tag>

            case "FRERE":
                text = "Frère / Sœur"
                if (homme === true) {
                    text = "Frère"
                }
                if (homme === false) {
                    text = "Sœur"
                }
                return <Tag color={"blue"}>{text}</Tag>


            case "GP":
                text = "Grand Père / Grand Mère"
                if (homme === true) {
                    text = "Grand Père"
                }
                if (homme === false) {
                    text = "Grand Mère"
                }
                return <Tag color={"green"}>{text}</Tag>

            case "PF":
                text = "Petit Fils / Petite Fille"
                if (homme === true) {
                    text = "Petit Fils"
                }
                if (homme === false) {
                    text = "Petite Fille"
                }
                return <Tag color={"blue"}>{text}</Tag>

            case "EX":
                text = "Ex Conjoint / Ex Conjointe"
                if (homme === true) {
                    text = "Ex Conjoint"
                }
                if (homme === false) {
                    text = "Ex Conjointe"
                }
                return <Tag color={"purple"}>{text}</Tag>


            case "BF":
                text = "Beau Frere / Belle Sœur"
                if (homme === true) {
                    text = "Beau Frere"
                }
                if (homme === false) {
                    text = "Belle Sœur"
                }
                return <Tag color={"purple"}>{text}</Tag>


            case "COUSIN":
                text = "Cousin / Cousine"
                if (homme === true) {
                    text = "Cousin"
                }
                if (homme === false) {
                    text = "Cousine"
                }
                return <Tag color={"purple"}>{text}</Tag>


            case "AMI":
                text = "Ami / Amie"
                if (homme === true) {
                    text = "Ami"
                }
                if (homme === false) {
                    text = "Amie"
                }
                return <Tag color={"purple"}>{text}</Tag>
        }
    }


    render() {
        const selected = this.state.selected
        const loading = this.state.loading
        const parent = this.props.parent

        //console.log(selected)

        let whatsappTel = selected?.tel?.replace("+", "") || ""
        if (whatsappTel.startsWith("0")) {
            whatsappTel = "33" + whatsappTel.slice(1)
        }

        return (
            <div>
                <PermissionAlert permissions={["contact.read"]}>
                    <Card loading={this.state.loading} title={this.state.loading ? "" :
                        <Text>{<ContactIcon
                            contact={selected}/>} {selected.nom} {selected.prenom} {selected.nomJF ? "(" + selected.nomJF + ")" : null}
                            {selected.deleted && <Tag color={"orange"} style={{marginLeft: 10}}>SUPPRIMÉ</Tag>}
                            {selected.archived &&(
                                <Popconfirm
                                    title={"Êtes-vous sûrs de vouloir déarchiver ce contact ?"}
                                    onConfirm={() => this.onUnarchiveContact()}
                                    okText="Oui"
                                    cancelText="Non"
                                    okType={"danger"}
                                >
                                    <Tag color={"blue"} style={{marginLeft: 10,cursor:"pointer"}}>ARCHIVÉ</Tag>
                                </Popconfirm>
                            )}
                        </Text>}
                          extra={<FicheHeader fiche={this} parent={parent} loading={loading} selected={selected}/>}>


                        {selected && (
                            <Fragment>

                                <div style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    flexDirection: isMobile ? "column" : "row-reverse"
                                }}>
                                    <div>
                                        <FicheAccess fiche={this} parent={parent} loading={loading}
                                                     selected={selected}/>
                                        <FicheShared fiche={this} parent={parent} loading={loading}
                                                     selected={selected}/>
                                        <FicheActions fiche={this} parent={parent} loading={loading}
                                                      selected={selected}/>
                                        <FicheParents fiche={this} parent={parent} loading={loading}
                                                      selected={selected}/>
                                    </div>

                                    <div>
                                        <FicheFamilles fiche={this} parent={parent} loading={loading}
                                                       selected={selected}/>
                                        <FicheCategories fiche={this} preview parent={parent} loading={loading}
                                                         selected={selected}/>
                                    </div>
                                </div>


                                <div style={{margin: "30px 0"}}>
                                    {(selected.tel || selected.email) && selected.parents.length == 0 && (
                                        <Row style={{flexWrap: "wrap", gap: 20}}>
                                            {selected.tel ? (
                                                <Card size={"small"}>
                                                    <Space>
                                                        <Button onClick={() => this.modalAddCom.addAppel(selected.id)}
                                                                size="small" target="_blank"
                                                                href={"https://wa.me/" + whatsappTel}
                                                                style={{backgroundColor: "#25D366", color: "#FFF"}}
                                                                shape={"circle"} icon={<WhatsAppOutlined/>}/>
                                                        <Button href={"tel:" + selected.tel}
                                                                onClick={() => this.modalAddCom.addAppel(selected.id)}><PhoneOutlined/> {selected.tel}
                                                        </Button>
                                                        <Button size="small" shape={"circle"} icon={<CopyOutlined />} onClick={() => {navigator.clipboard.writeText(selected.tel)}}/>
                                                    </Space>
                                                </Card>

                                            ) : ""}
                                            {selected.email ? (
                                                <Card size={"small"}>
                                                    <Space>
                                                        <Button
                                                            href={"mailto:" + selected.email}><MailOutlined/> {selected.email}
                                                        </Button>
                                                        <Button size="small" shape={"circle"} icon={<CopyOutlined />} onClick={() => {navigator.clipboard.writeText(selected.email)}}/>
                                                    </Space>
                                                </Card>
                                            ) : ""}
                                        </Row>
                                    )}

                                    <FicheTels fiche={this} parent={parent} loading={loading} selected={selected}/>
                                    <FicheEmails fiche={this} parent={parent} loading={loading} selected={selected}/>
                                </div>


                                <FicheInfos fiche={this} parent={parent} loading={loading} selected={selected}/>

                                <FicheTabs fiche={this} parent={parent} loading={loading} selected={selected}/>

                            </Fragment>
                        )}
                    </Card>
                    <ModalEdit getRef={(ref) => this.modalEdit = ref} onFinish={() => {
                        this.getData()
                        //this.getFamilles()
                    }}/>
                    <ModalAddDoc getRef={(ref) => this.modalAddDoc = ref} onFinish={() => this.getData()}/>
                    <ModalAddLink getRef={(ref) => this.modalAddLink = ref} onFinish={() => this.getData()}/>
                    <ModalAddCom getRef={(ref) => this.modalAddCom = ref} onFinish={() => this.getData()}/>
                    <ModalAddField getRef={(ref) => this.modalAddField = ref} onFinish={() => this.getData()}/>
                    <ModalAddChild getRef={(ref) => this.modalAddChild = ref} onFinish={(id) => {
                        this.modalContact.show(id)
                        this.getData()
                    }}/>

                    <ModalMergeContact getRef={(ref) => this.modalMergeContact = ref} onFinish={(id) => {
                        this.setState({loading: true})
                        parent.init()
                        parent.getData()
                    }}/>

                    <ModalAddTel getRef={(ref) => this.modalAddTel = ref} onFinish={(data) => {
                        if (data) {
                            this.modalContact.show(data.id)
                        }
                        this.getData()
                    }}/>

                    <ModalAddEmail getRef={(ref) => this.modalAddEmail = ref} onFinish={(data) => {
                        if (data) {
                            this.modalContact.show(data.id)
                        }
                        this.getData()
                    }}/>

                    <ModalAddFamilyLink getRef={(ref) => this.modalAddFamilyLink = ref}
                                        onFinish={() => this.getData()}/>
                    <ModalEditAdresse getRef={(ref) => this.modalEditAdresse = ref} onFinish={() => this.getData()}/>

                    <ModalUser getRef={(ref) => this.modalUser = ref} onFinish={() => {
                    }}/>
                    <ModalCerfa getRef={(ref) => this.modalCerfa = ref} onFinish={() => {
                    }}/>
                    <ModalAbonnement getRef={(ref) => this.modalAbonnement = ref} onFinish={() => {
                    }}/>
                    <ModalPromesse getRef={(ref) => this.modalPromesse = ref} onFinish={() => {
                    }}/>

                    <ModalAddTag getRef={(ref) => this.modalAddTag = ref} onFinish={(tag) => this.getData()}/>
                    <ModalHazkara getRef={(ref) => this.modalHazkara = ref} onFinish={(tag) => this.getData()}/>
                    <ModalAddFamille getRef={(ref) => this.modalAddFamille = ref} onFinish={() => this.getData()}/>

                    <ModalContact getRef={(ref) => this.modalContact = ref} onFinish={() => {
                    }}/>
                    <ModalActivity getRef={(ref) => this.modalActivity = ref}/>
                </PermissionAlert>
            </div>
        )
    }
}

